import React, { PureComponent } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, Cell } from "recharts";
import Teams from "../../../../../api/Teams";
import CustomLabel from "./custom-label";

const AxisLabel = ({ axisType, x, y, width, height, stroke, children }) => {
  const isVert = axisType === "yAxis";
  const cx = isVert ? x : x + width / 2;
  const cy = isVert ? height / 2 + y : y + height + 10;
  const rot = isVert ? "270 0 0" : 0;

  return (
    <text
      x={cx}
      y={cy}
      transform={`rotate(${rot})`}
      textAnchor="middle"
      stroke={stroke}
    >
      {children}
    </text>
  );
};

class ProductCostsChart extends PureComponent {
  getColor(i) {
    const baseColors = Teams.competitiveColors();
    return baseColors[i % baseColors.length];
  }

  get dataValues() {
    let data = [];

    this.props.data.forEach(item => {
      const { team, value } = item;

      data.push({
        team,
        "Average unit Costs ($)": value
      });
    });

    return data;
  }

  get margin() {
    return {
      top: 20,
      left: 0,
      right: 0,
      bottom: 0
    };
  }

  render() {
    return (
      <div className="text-center">
        <div id="chartHorizontalBarProductCosts" className="horizontalBar">
          <BarChart
            layout="vertical"
            width={220}
            height={230}
            data={this.dataValues}
            margin={this.margin}
          >
            <YAxis
              type="category"
              dataKey="team"
              label={
                <AxisLabel axisType="yAxis" x={-110} y={40} height={0}>
                  Team
                </AxisLabel>
              }
              tick={false}
            />
            <XAxis
              type="number"
              label={
                <AxisLabel
                  axisType="xAxis"
                  x={140}
                  y={220}
                  width={0}
                  height={0}
                >
                  Average unit Costs ($)
                </AxisLabel>
              }
              domain={[dataMin => 0, dataMax => Math.ceil(dataMax * 1.6)]}
            />
            <Tooltip />
            <Bar
              dataKey="Average unit Costs ($)"
              barSize={18}
              stackId="a"
              minPointSize={5}
              label={
                <CustomLabel
                  precision={2}
                  prefix="$"
                  suffix=""
                  layout="vertical"
                />
              }
            >
              {this.dataValues.map((value, i) => (
                <Cell key={i} fill={this.getColor(i)} />
              ))}
            </Bar>
          </BarChart>
        </div>
      </div>
    );
  }
}

export default ProductCostsChart;



// WEBPACK FOOTER //
// ./src/components/ceo/analysis/competitive/charts/product-costs.js